export default {
    path:'*',
    preload:true
  }